<template>
	<v-container fluid grid-list-lg class="pa-3">
		<v-layout row wrap>
			<v-flex class="pt-0">
				<v-card>
					<v-tabs v-model="tabs.active" slider-color="secondary">
						<v-tab ripple>
							Basic Info
						</v-tab>
						<v-tab ripple>
							Listing
						</v-tab>

						<v-tab-item class="pa-3">
							<v-form ref="MainForm" lazy-validation>
								<v-container fluid class="pa-0">
									<v-layout row wrap>
										<v-flex xs12 sm10>
											<v-text-field readonly label="Label (required)" hint="Short description" maxlength="50" v-model="selected.report_label" counter></v-text-field>
										</v-flex>

										<v-flex xs12 sm2>
											<v-select :items="fpes_status" readonly v-model="selected.status_id" item-text="label" item-value="_id" label="Status">
											</v-select>
										</v-flex>
									</v-layout>

									<v-layout>
										<v-flex>
											<v-textarea readonly label="Description" hint="Full description about this report" maxlength="200" v-model="selected.description" counter></v-textarea>
										</v-flex>
									</v-layout>

									<v-layout row wrap>
										<v-flex xs12 sm6 md3>
											<v-text-field v-model="selected.start_date" label="Start Date (required)" hint="Start date in YYYY-MM-DD format" persistent-hint readonly prepend-icon="event"></v-text-field>
										</v-flex>

										<v-flex xs12 sm6 md3>
											<v-text-field v-model="selected.end_date" label="End Date (required)" hint="End date in YYYY-MM-DD format" persistent-hint readonly prepend-icon="event"></v-text-field>
										</v-flex>

										<v-flex xs12 sm6 md3>
											<v-text-field v-model="selected.created_by" label="Created by" hint="Created date/time:" :messages="epoch2date(selected.created)" readonly></v-text-field>
										</v-flex>

										<v-flex xs12 sm6 md3>
											<v-text-field readonly :messages="epoch2date(selected.modified)" v-model="selected.modified_by" hint="Last modified date/time:" label="Last modified by"></v-text-field>
										</v-flex>
									</v-layout>
								</v-container>
							</v-form>
						</v-tab-item>

						<v-tab-item>
							<v-container fluid class="dull">
								<v-layout row wrap>
									<v-flex xs12 sm6>
										<v-text-field
											label="Filter Full Name:"
											v-model="table.filter_by_name"
											placeholder="Fitcorper Full Name"
											clearable
											@keydown.enter="reload_fpes_report_entries"
											@click:clear="filter_onclear">
										</v-text-field>
									</v-flex>
									<v-flex xs12 sm6>
										<v-text-field
											label="Filter by Company or Dept:"
											v-model="table.filter_by_company_dept"
											placeholder="Filter by Company or Dept"
											clearable
											@keydown.enter="reload_fpes_report_entries"
											@click:clear="filter_onclear">
										</v-text-field>
									</v-flex>
								</v-layout>
							</v-container>

							<v-data-table
								:pagination.sync="table.pagination"
								:total-items="table.total_items"
								:rows-per-page-items="table.rows_per_page_items"
								:headers="table.headers.filter((r) => r.viewable == true)"
								:loading="table.loading" :items="table.items">

								<template v-slot:items="props">
									<td class="px-0">
										<v-menu bottom right>
											<template v-slot:activator="{ on }">
												<v-btn small icon v-on="on">
													<v-icon color="primary">more_vert</v-icon>
												</v-btn>
											</template>

											<v-list dense class="pa-0">
												<v-list-tile :href="'/Submit-Evidence-Crud/?uuid=dc0931b5-f388-421d-85ac-01024faa9160&_id=' + props.item._id">
													<v-list-tile-action>
														<v-icon>file_upload</v-icon>
													</v-list-tile-action>
													<v-list-tile-title>Upload Evidence</v-list-tile-title>
												</v-list-tile>
											</v-list>
										</v-menu>
									</td>
									<td><b>{{ props.item.username }}</b></td>
									<td>{{ props.item.full_name }}</td>
									<td v-html="display_company_dept(props.item.company_dept)"></td>
									<td v-html="populate_appraisal_list_items(props.item.appraisals)"></td>
									<td>{{ props.item.eul }}</td>
									<td>{{ props.item.lateness }}</td>
									<td>{{ props.item.mc }}</td>
									<td>{{ props.item.remark }}</td>
									<td>{{ props.item.ack_status }}</td>
									<td>{{ props.item.ack_type }}</td>
								</template>
							</v-data-table>
						</v-tab-item>
					</v-tabs>


				</v-card>
			</v-flex>
		</v-layout>


	</v-container>
</template>

<script>
import query_builder from "../../functions/query.builder";
import general from "../../functions/general";

export default {
	name: "Submit-Evidence",
	data() {
		return {
			fpes_status: [],
			tabs: {
				active: 1
			},
			selected: {
				_id: "",
				created: "",
				created_by: "",
				modified: "",
				modified_by: "",
				start_date: "",
				end_date: "",
				status_id: "",
				total_emps: 0,
				top_rate: 60,
				bottom_rate: 10,
				report_label: "",
				description: "",
			},
			table: {
				headers: [
					{
						text: "",
						value: "",
						align: "left",
						sortable: false,
						viewable: true,
						type: "Number",
						class: "px-0",
						width: "30px",
					},
					{
						text: "ID",
						value: "_id",
						align: "left",
						sortable: false,
						viewable: false,
						type: "Number",
						class: "",
						width: "",
					},
					{
						text: "User Name",
						value: "username",
						align: "left",
						sortable: true,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Full Name",
						value: "full_name",
						align: "left",
						sortable: true,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Comapany : Dept",
						value: "company_dept",
						align: "left",
						sortable: true,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Appraisal Score",
						value: "appraisals",
						align: "left",
						sortable: true,
						viewable: true,
						type: "Number",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "EUL",
						value: "eul",
						align: "left",
						sortable: true,
						viewable: true,
						type: "Number",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Lateness",
						value: "lateness",
						align: "left",
						sortable: true,
						viewable: true,
						type: "Number",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "MC",
						value: "mc",
						align: "left",
						sortable: true,
						viewable: true,
						type: "Number",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Remark",
						value: "remark",
						align: "left",
						sortable: true,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Ack Status",
						value: "ack_status",
						align: "left",
						sortable: true,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Ack Type",
						value: "ack_type",
						align: "left",
						sortable: true,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: "",
					},
				],
				items: [],
				loading: false,
				total_items: 0,
				filter_by_name: "",
				filter_by_company_dept: "",
				rows_per_page_items: [25, 50, 100, 200, 1000],
				pagination: {
					descending: false,
					page: 1,
					rowsPerPage: 1000,
					sortBy: "full_name",
					totalItems: 100,
				},
			},
		};
	},
	computed: {},
	watch: {
		"table.pagination": {
			handler: function () {
				this.reload_fpes_report_entries();
			},
			deep: true,
		},
	},
	methods: {
		filter_onclear() {
			this.$nextTick(()=>{
				this.reload_fpes_report_entries();
			});
		},
		display_company_dept(value) {
			let ret = "";
			let list = value.split(",");

			if (list.length > 0) {
				ret = "<ol><li>";

				ret += list.join("</li><li>");
				ret += "</li></ol>";
			}

			return ret;
		},
		populate_appraisal_list_items(arr) {
			let superior = [], self = [], peer = [];

			for (var i = 0, m = arr.length; i < m; i++) {
				let el = arr[i];

				if (el.type.includes("Superior")) {
					superior.push(el.ave_score);
				} else if (el.type.includes("Self")) {
					self.push(el.ave_score);
				} else if (el.type.includes("Peer")) {
					peer.push(el.ave_score);
				}
			}

			let html_text = `
			<ul class="font-weight-light">
				<li>Superior : ${this.average_score(superior)}</li>
				<li>Self : ${this.average_score(self)}</li>
				<li>Peer : ${this.average_score(peer)}</li>
			</ul>
			`;

			return html_text;
		},
		average_score(list) {
			let ret = "-";
			let list_length = list.length;

			if (list_length > 0) {
				let sum_value = 0
				for (let i = 0; i < list_length; i++) {
					sum_value += list[i];
				}

				ret = (sum_value / list_length).toFixed(2);
			}


			return ret;
		},
		epoch2date: general.App.epoch2LocaleDatetime,
		async reload_fpes_report_entries() {
			if (!this.selected._id) {
				return;
			}
			var qb = new query_builder.QueryBuilder();

			qb.Table = "fpes_report_entries_view";

			var rule = new query_builder.Rule();
			rule
				.field("fpes_report_id")
				.operator(query_builder.A_STR_OPERATOR.EQUAL)
				.value(this.selected._id);
			qb.Where.rules.push(rule);

			if (this.table.filter_by_name != null && this.table.filter_by_name.length > 0) {
				rule = new query_builder.Rule();

				rule
					.field("full_name")
					.operator(query_builder.A_STR_OPERATOR.I_CONTAINS)
					.value(this.table.filter_by_name);
				qb.Where.rules.push(rule);
			}

			if (this.table.filter_by_company_dept != null && this.table.filter_by_company_dept.length > 0) {
				rule = new query_builder.Rule();

				rule
					.field("company_dept")
					.operator(query_builder.A_STR_OPERATOR.I_CONTAINS)
					.value(this.table.filter_by_company_dept);
				qb.Where.rules.push(rule);
			}

			qb.Limit = this.table.pagination.rowsPerPage;
			qb.Offset = this.table.pagination.page;
			qb.Select = this.table.headers.filter(el => (el.viewable == true && el.value != "") || el.value == "_id");

			// must check sortBy before push in order array
			if (this.table.pagination.sortBy) {
				qb.Order = [
					{
						name: this.table.pagination.sortBy,
						descending: this.table.pagination.descending,
					},
				];
			}

			var res = await general.wBackEndComm.PostData("fpes/get_fpes_entries_by_user_role/", qb);
			res = res.data;
			if (res.Status == 1) {
				this.table.items = res.Body[0].records;
				this.table.total_items = res.Body[0].total_records;
			} else {
				general.wMsgBox.Error(res.Description);
			}
		},
	},
	async mounted() {
		general.App.loader.show(this);
		general.App.set_page_title("mySuite : Performance Evaluation Page");

		this.fpes_status = await general.App.arango_app_selections("fpes_report", "status");
		this.selected._id = general.App.getQueryString("_id");

		// initialize
		if (!this.selected._id) {
			this.selected.status_id = this.fpes_status[0]["_id"];
		} else {
			let url1 = "fpes/report_crud/?_id=" + this.selected._id;

			let result1 = await general.wBackEndComm.GetData(url1);
			result1 = result1.data;

			if (result1.Status == 1) {
				this.selected = result1.Body;

				if (this.selected.status_id == this.fpes_status[1]._id) {
					await this.reload_fpes_report_entries();
				}
			} else {
				general.wMsgBox.Error(result1.Description);
			}
		}

		general.App.loader.hide(this);
	},
};
</script>

<style scoped></style>
